module.exports = __webpack_public_path__ + "static/media/concept_for_lobby_mural_at_herbal_medicine_company_2019.8952e0fe.webp";